import { route, Router } from "preact-router";
import "./style/index.css";
import SignInScreen from "./routes/sign-in";
import WelcomeScreen from "./routes/welcome";
import HomeScreen from "./routes/home";
import styled from "@emotion/styled";
import Navbar from "./components/common/navbar";
import SettingsScreen from "./routes/setting";
import AnalyticsScreen from "./routes/analytics";
import { Provider } from "react-redux";
import store from "./store";
import { getCookie, getLocalStorage } from "./utils";
import { useEffect, useState } from "preact/hooks";
import { Fragment } from "preact";
import BasicModal from "./components/common/basicModal";
import { modalConfig } from "./actionTypes";
import { Button } from "@mui/base";
import RecentlyPlayed from "./components/recentlyPlayed";
import AdminOfferScreen from "./routes/adminOffer";
import ClaimOfferScreen from "./routes/claimOffer";
import EventDashboardScreen from "./routes/eventDashboard";
import EventOfferScreen from "./routes/eventOffer";
import MustTryScreen from "./routes/mustTry";
import ServicesScreen from "./routes/services";
import PromoteScreen from "./routes/promote";
import CheckInScreen from "./components/checkIn";
import SubscriptionScreen from "./routes/subscription";
import { Toaster } from "react-hot-toast";
import VerificationError from "./components/VerificationError";

const MainContainer = styled("div")`
  display: flex;
  height: 100vh;
  width: 100%;
  background-color: black;
  .contentWrapper {
    display: flex;
    width: 100%;
    color: #fff;
    flex-direction: column;
    align-items: center;
    padding: 0px 30px;

    flex: 1;
    min-width: 0;
    overflow-y: auto;
  }
  @media only screen and (max-width: 724px) {
    .contentWrapper {
      padding: 0 10px;
    }
  }
`;
export default function App() {
  const [showReloadModal, setShowReloadModal] = useState(false);

  const handleCloseSlotCloseModal = () =>
    store.dispatch({ type: modalConfig.CLOSE_REFRESH_MODAL });

  useEffect(() => {
    store.subscribe(() => {
      setShowReloadModal(store.getState().config.showRefreshModal);
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        ["/", "sign-in", "forgot-password", "verification-error"].includes(
          window.location.pathname.length > 1
            ? window.location.pathname.replaceAll("/", "")
            : window.location.pathname
        )
      ) {
        if (getCookie("user_key")) {
          if (getLocalStorage("business_type") === "brand") {
            route("/services", true);
          } else if (
            getLocalStorage("business_type") &&
            getLocalStorage("business_type") !== undefined &&
            getLocalStorage("business_type") !== ""
          ) {
            console.log(
              "route to home in interval",
              getLocalStorage("business_type")
            );
            route("/home", true);
          }
        }
        return;
      }
      if (!getCookie("user_key")) {
        route("/verification-error", true);
      }
    }, 2000);

    const timeout = setTimeout(() => {
      if (
        ["/", "sign-in", "forgot-password", "verification-error"].includes(
          window.location.pathname.length > 1
            ? window.location.pathname.replaceAll("/", "")
            : window.location.pathname
        )
      ) {
        if (getCookie("user_key")) {
          if (getLocalStorage("business_type") === "brand") {
            route("/services", true);
          } else if (
            getLocalStorage("business_type") &&
            getLocalStorage("business_type") !== undefined &&
            getLocalStorage("business_type") !== ""
          ) {
            console.log(
              "route to home timeout",
              getLocalStorage("business_type")
            );
            route("/home", true);
          }
        }
        return;
      } else {
        if (!getCookie("user_key")) {
          route("/", true);
          return;
        }
      }
    }, 500);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [getCookie("user_key")]);

  return (
    <Provider store={store}>
      <MainContainer>
        <Router>
          <WelcomeScreen path="/" />
          <SignInScreen path="/sign-in" />
          <VerificationError path="/verification-error" />
          <MainContainer path="/:rest*">
            <Navbar />
            <div className="contentWrapper">
              {/* <Header /> */}
              <Router>
                <HomeScreen path="/home" />
                <SettingsScreen path="/setting" />
                <AnalyticsScreen path="/analytics" />
                <RecentlyPlayed path="/played-songs" />
                <AdminOfferScreen path="/admin-offer" />
                <ClaimOfferScreen path="/claim-offer" />
                <EventOfferScreen path="/event-offer" />
                <EventDashboardScreen path="/event-dashboard" />
                <MustTryScreen path="/must-try" />
                <ServicesScreen path="/services" />
                <PromoteScreen path="/promote" />
                <CheckInScreen path="/check-in" />
                <SubscriptionScreen path="/subscription" />
              </Router>
              <Toaster
                position="top-center"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: "#363636",
                    color: "#fff",
                  },
                }}
              />
            </div>
          </MainContainer>
        </Router>
        <Fragment>
          <BasicModal
            open={showReloadModal}
            handleClose={handleCloseSlotCloseModal}
          >
            <div className="modalHeaderText">Refresh</div>
            <div className="modalSubText">
              Weak connection. Please check your network and reload.
            </div>

            <Button
              onClick={() => {
                store.dispatch({
                  type: modalConfig.CLOSE_REFRESH_MODAL,
                });
                window.location.reload();
              }}
              className="modalButton"
            >
              Reload
            </Button>
          </BasicModal>
        </Fragment>
      </MainContainer>
    </Provider>
  );
}
